import useEmailAllowlist from "./useEmailAllowlist";

// Gates /on-hold-payouts, /bulk-add-coins and the Verify Liveness button.
// Deliberately NOT the same set as COIN_LOGS_EMAILS in useCoinLogsAccess —
// sukru@ has super-admin without coin-logs access. Adding or removing a person
// here is a source change and a deploy.
const SUPER_ADMIN_EMAILS = [
  "flo@gamelight.io",
  "gunay@gamelight.io",
  "sukru@gamelight.io",
];

export default function useSuperAdmin() {
  return useEmailAllowlist(SUPER_ADMIN_EMAILS);
}
